module.exports = __webpack_public_path__ + "img/query.8ce1c7f8.png";